import { render, staticRenderFns } from "./IdCheckGroup.vue?vue&type=template&id=b254601e&"
import script from "./IdCheckGroup.vue?vue&type=script&lang=ts&"
export * from "./IdCheckGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports